import React from 'react';

export function useSafeContext<T>(
    context: React.Context<T>,
    errorMessage = `${
        context.displayName ?? 'Context'
    } consumer hook must be used within a Provider`
): NonNullable<T> {
    const ctx = React.useContext(context);
    if (!ctx) {
        throw new Error(errorMessage);
    }
    return ctx;
}
